import classNames from 'classnames';
import feather from 'feather-icons';
import React, { CSSProperties, memo, useEffect } from 'react';
import { Styled } from '../../types';

type FeatherIconProps = CSSProperties &
  Styled & {
    name: string;
    size?: number;
  };

const FeatherIcon = ({
  name,
  size = 24,
  className = '',
  ...style
}: FeatherIconProps) => {
  useEffect(() => {
    feather.replace();
  }, [size]);
  return (
    <div
      className={classNames(className)}
      style={{
        ...style,
        width: size,
        height: size
      }}
    >
      <i
        data-feather={name}
        style={{ ...style }}
        {...{
          width: size,
          height: size
        }}
      />
    </div>
  );
};

export default memo(FeatherIcon);
